import { Completion } from '@codemirror/autocomplete'
import { json, jsonParseLinter } from '@codemirror/lang-json'
import { linter, lintGutter } from '@codemirror/lint'
import { Typography } from '@mui/material'
import { mentions } from '@uiw/codemirror-extensions-mentions'
import CodeMirror from '@uiw/react-codemirror'
import _ from 'lodash'
import algo from '../../../core/Algo'
import { IFlow, INode, NodeType } from '../../../definitions/Nodes'
import { IAcceptedData } from '../../../definitions/NodesDescription'
import NodeManager from '../../../managers/NodeManager'
import { useAppSelector } from '../../../store/Hooks'

interface P {
    acceptedData: IAcceptedData<NodeType>
    selectedNode: INode<NodeType>
    flow: IFlow
    setSelected: (node: INode) => void
    disable: boolean
}

function NodeJSONEditor({ acceptedData, selectedNode, flow, setSelected, disable }: P) {
    const value: string = selectedNode.data[acceptedData.parameter]
    const errorNoInput = acceptedData.isRequired && (!algo.hasVal(value) || value.length === 0)
    const mode = useAppSelector(state => state.app.mode)

    const listKeyValue = NodeManager.getListInputs(flow, selectedNode)

    const listMentions: Completion[] = listKeyValue.map(x => {
        return {
            label: '@{' + x.label + '}',
            displayLabel: '@' + x.label,
            section: x.type
        }
    })

    let trimedText: string = _.cloneDeep(value) ?? ''
    for (let i = 0; i < listKeyValue.length; i++) {
        const keyValue = listKeyValue[i]
        trimedText = trimedText.replaceAll(keyValue.value, keyValue.label)
    }

    return (
        <div style={{ height: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Typography color={errorNoInput ? 'red' : undefined}>{acceptedData.parameter}</Typography>
            <CodeMirror
                readOnly={disable}
                theme={mode === 'dark' ? 'dark' : 'light'}
                style={{ color: 'red', colorScheme: 'dark', border: errorNoInput ? '1px solid red' : undefined, flex: 1, height: '100%', display: 'flex', overflow: 'auto' }}
                value={trimedText}
                width='100%'
                minHeight='30vh'
                extensions={[json(), mentions(listMentions), lintGutter(), linter(jsonParseLinter())]}
                onChange={(value: string) => {
                    let trimmedValue: string = _.cloneDeep(value) ?? ''
                    for (let i = 0; i < listKeyValue.length; i++) {
                        const keyValue = listKeyValue[i]
                        trimmedValue = trimmedValue.replaceAll(keyValue.label, keyValue.value)
                    }

                    setSelected({ ...selectedNode, data: { ...selectedNode.data, [acceptedData.parameter]: trimmedValue } })
                }}
            />
        </div>
    )
}

export default NodeJSONEditor
